<template>
    <v-container>
        <v-card>
            <v-card-title>{{text.administrator.ecEventList}}{{text.administrator.ecEventListHelp}}<v-spacer></v-spacer><v-icon @click="sEventList = !sEventList">mdi-arrow-expand-vertical</v-icon></v-card-title>
            <v-card-text v-show="sEventList">
                <v-simple-table>
                    <thead>
                        <tr>
                            <th>{{text.administrator.eventColumn.date}}</th>
                            <th>{{text.administrator.eventColumn.mode}}</th>
                            <th>{{text.administrator.eventColumn.overview}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr @click="viewEvent(eventInfo.eventId)" v-for="eventInfo in ecEventList" :key="eventInfo.eventId" v-show="eventInfo._show" class="hoverPointer">
                            <th>{{eventInfo.regDate}}</th>
                            <th>{{eventInfo.mode}}</th>
                            <th>{{eventInfo.overview}}</th>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>
        </v-card>
        <v-card v-show="sEventDetail">
            <v-container>
                <v-row>
                    <span class="text-h4">{{viewEventDetail}}</span>
                </v-row>
                <v-row>
                    {{text.dataGetDate}}:{{getDate}}
                    <v-btn @click="updateEventDetail">{{text.update}}</v-btn>
                </v-row>
                <v-row>
                    <v-btn @click="exportExcel" :disabled="disExcelBtn">{{text.excel}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="ecAdmin" v-show="!disCloseBtn" @click="digCloseEvent = true">{{text.administrator.ecEventClose}}</v-btn>
                </v-row>
                <v-row><!--Chart-->
                <v-subheader><span class="text-h5">{{text.reportHead}}</span><span>*{{text.reportHeadHelp}}</span></v-subheader>
                    <v-container>
                        <v-row ref="charts">
                        </v-row>
                    </v-container>
                </v-row>
                <v-row><!--DetailList-->
                    <v-subheader><span class="text-h5">{{text.reportListHead}}</span><span>*{{text.reportListHeadHelp}}</span></v-subheader>
                    <v-container class="ma-0 pa-0">
                    <v-text-field class="ma-0 pa-0" v-model="reportList.serchTxt" :label="text.serchCodeName" @input="serchInput"></v-text-field>
                    <v-menu v-model="listMenu.display" :position-x="listMenu.x" :position-y="listMenu.y" absolute>
                        <v-list>
                            <v-list-item-group>
                            <v-list-item><span class="hoverPointer" @click="answerReport">{{text.answerReport}}</span></v-list-item>
                            <v-list-item><span class="hoverPointer" @click="openMemo">{{text.memoDetail}}</span></v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-menu>
                    <v-tooltip v-model="memoTip.display" right :position-x="memoTip.x" :position-y="memoTip.y">
                        <div>
                            {{text.ecMemo.title}}
                            <div v-show="memoTip.memoCount === 0">
                                {{text.ecMemo.noMemo}}
                            </div>
                            <p v-show="memoTip.memoCount !== 0">
                                {{text.ecMemo.date}}:{{memoTip.date}}<br>
                                {{text.ecMemo.user}}:{{memoTip.user}}<br>
                                {{text.ecMemo.text}}:<br>{{memoTip.text}}
                            </p>
                            <p v-show="memoTip.memoCount > 1" style="border-top:groove 2px #FFFFFF">
                                {{memoTip.otherCount}}
                            </p>
                        </div>
                    </v-tooltip>
                    <v-data-table dense :search="reportList._serchTxt" :headers="reportData.reportHeders" :items="reportData.reportData" :custom-filter="listFilter">
                        <template v-slot:body="{items}">
                            <tbody  @mouseleave="closeTip">
                            <tr v-for="reportitem in items" :key="reportitem[0]" @contextmenu="(e)=>listMenuOpen(e,reportitem)" @mouseenter="(e)=>openTip(e,reportitem)">
                                <td v-for="column in reportitem" :key="column">{{column}}</td>
                            </tr>
                            </tbody>
                        </template>
                    </v-data-table>
                    </v-container>
                </v-row>
            </v-container>
        </v-card>
        <v-dialog persistent v-model="digMemo" max-width="500">
            <v-card>
                <v-card-title>{{text.memoDetail}}({{memoDetail.count}})<v-spacer></v-spacer><span class="hoverPointer" @click="digMemo=false">×</span></v-card-title>
                <v-card-subtitle>
                    {{memoDetail.userName}}({{memoDetail.userDep}})
                </v-card-subtitle>
                <v-card-text style="border:groove 2px #FFFFFF;overflow: scroll;max-height:35ex">
                    <v-container>
                    <v-card color="blue-grey lighten-5" v-for="memoData in memoDetail.memos" :key="memoData.updateText">
                        <p>
                            {{text.ecMemo.date}}:{{memoData.updateText}}<br>
                            {{text.ecMemo.user}}:{{memoData.user}}<br>
                            {{text.ecMemo.text}}:<br>{{memoData.text}}
                        </p>
                    </v-card>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-text-field autocomplete="off" outlined v-model="inputMemoText"></v-text-field>
                    <v-btn @click="inputMemo">{{text.inputMemo}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="digCloseEvent" max-width="500">
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                    {{text.messege.closeEventConf}}<br>
                    {{text.messege.cantRedo}}<br>
                </v-card-text>
                <v-card-actions>
                    <div class="d-flex flex-column">
                    <v-alert type="warning" v-show="noReportUser">{{text.administrator.noReportUser}}</v-alert>
                    <v-btn @click="digCloseEvent = false">{{text.no}}</v-btn>
                    <v-checkbox v-model="lockCloseBtn" :label="text.administrator.lockCloseBtn"></v-checkbox>
                    <v-btn :disabled="!lockCloseBtn" @click="closeEventExec">{{text.yes}}</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script lang="ts">
    import Vue from 'vue';
    import lang from "../lang";
    let text = new lang(0);
    import exceljs, { PaperSize } from "exceljs";
    import fileSaver from "file-saver";
    import {apiRequest} from "../lib/api";
    import * as comm from '../common';
    import * as type from '../types';
    import pieComponent from './pieChart.vue';
    interface vueRefForm extends Vue{
        validate:()=>boolean;
    }
    interface vueChart extends Vue{
        sysSet:(id:number,title:string)=>void;
        update:(datasets:{data:number[],labels:string[]})=>void;
        resetEmphasis:(activeId:number|null)=>void;
        getLegend:()=>number|null;
        setPadding:(padding:number)=>void;
    }
    interface memoData{
        count:number,
        detail:memoDetails
    }
    type memoDetails = Array<{
        update:Date|null,
        updateText:string,
        user:string,
        text:string,
        }>
    export default Vue.extend({
        data: () => ({
            text : text.Text,
            api:null as null|{connection:boolean,apiRequest:null|apiRequest},
            getDate:"",
            disCloseBtn:false,
            disExcelBtn:false,
            noReportUser:false,
            digCloseEvent:false,
            digMemo:false,
            sEventList:true,
            sEventDetail:false,
            selectEventId:"",
            viewEventDetail:"",
            inputMemoText:"",
            lockCloseBtn:false,
            ecEventList:[] as Array<{eventId:string,_regDate:Date,regDate:string,_mode:number,mode:string,overview:string,_show:boolean}>,
            userReportId:{} as {[userid:string]:string},
            userAnswered:{} as {[userid:string]:boolean},
            currentEventId:"",
            reportList:{
                serchTxt:"",
                _serchTxt:"" as null|string,
                answerFilter:"",
                answerIndex:-1,
            },
            reportData:{
                reportHeders:[] as Array<type.Vuetify_data_table_heders>,
                reportColumnFilter:[] as Array<null|Array<string>>,
                reportData:[] as Array<Array<string>>,
            } as type.reportData,
            reportColumn:[] as Array<type.reportQuColumn>,
            charts:[] as Array<{
                subject:string,
                data:Array<number>,
                labels:Array<string>,
                elm:vueChart
            }>,
            emphasis:{
                "columnId":null as number|null,
                "title":"",
                "item":"",
                "set":false,
            },
            listMenu:{
                display:false,
                x:0,
                y:0,
                userId:null as string|null,
                userName:"",
                userDep:"",
                reportId:"",
            },
            memoList:{} as {[userId:string]:memoData},
            memoTip:{
                display:false,
                x:0,
                y:0,
                date:"",
                user:"",
                text:"",
                otherCount:"",
                memoCount:0,
            },
            memoDetail:{
                userId:"",
                userName:"",
                userDep:"",
                count:null as null|number,
                memos:null as null|memoDetails
            }
        }),
        mounted() {
            this.api = this.$store.state.apiSaver;
        },
        props:{
            ecAdmin:Boolean,
        },
        methods:{
            async getEcEvent(){
                if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    const result = await this.api.apiRequest.request.getEvents();
                    comm.LoadingOverlay(this,false);
                    if(result.statusCode === 200 && result.data){
                        const eventList = result.data;
                        if(eventList){
                            this.sEventDetail = false;
                            this.ecEventList = eventList.filter(l=>{
                                if(l.eventMode >=0 && l.eventMode <=3){
                                    return true;
                                }else{
                                    return false;
                                }
                            }).map(v=>{
                                let ovv = "";
                                if(v.alertInfo.type === "earthquake" && v.alertInfo.earthquake){
                                    ovv = this.text.earthquake + "/";
                                    ovv += v.alertInfo.earthquake.maxIntText
                                }
                                if(v.alertInfo.type === "training" && v.alertInfo.training){
                                    ovv = v.alertInfo.training.messege;
                                }
                                if(v.alertInfo.type === "manual" && v.alertInfo.manual){
                                    ovv = v.alertInfo.manual.subject;
                                }
                                return {
                                    "eventId":v.eventId,
                                    "_regDate":new Date(v.eventDate),
                                    "regDate":comm.formatDate(new Date(v.eventDate),"mm/dd HH:MM"),
                                    "_mode":v.eventMode,
                                    "mode":this.text.ecEventMode[v.eventMode],
                                    "overview":ovv,
                                    "_show":true,
                                } as {eventId:string,_regDate:Date,regDate:string,_mode:number,mode:string,overview:string,_show:boolean}
                            });
                        }
                    }else if(result.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                }else{
                    comm.ApiErrorMessege(this,comm.unknowError,true);
                }
            },
            async viewEvent(eventId:string){
                if(this.api && this.api.connection && this.api.apiRequest){
                    this.currentEventId = "";
                    comm.LoadingOverlay(this,true);
                    const result = await this.api.apiRequest.request.getEcReportsList(eventId);
                    comm.LoadingOverlay(this,false);
                    if(result.statusCode === 200 && result.data){
                        this.currentEventId = eventId;
                        this.getDate = comm.formatDate(new Date(),'mm/dd HH:MM:SS');
                        const apidata = result.data;
                        this.selectEventId = eventId;
                        this.noReportUser = apidata.flags.unanswer;
                        for(const [k,v] of Object.entries(this.ecEventList)){
                            if(v.eventId === eventId){
                                v._show = true;
                                if(v._mode === 2){
                                    this.disCloseBtn = false;
                                }else{
                                    this.disCloseBtn = true;
                                }
                                this.viewEventDetail = `${v.overview}@${v.regDate}(${v.mode})`;
                            }else{
                                v._show = false;
                            }
                        }
                        this.sEventDetail = true;
                        //固定項目
                        this.reportData.reportHeders = [
                            {"text":this.text.pCode,"value":"0"},
                            {"text":this.text.userName,"value":"1"},
                            {"text":this.text.depertment,"value":"2"},
                            {"text":this.text.answerUser,"value":"3"},
                        ];
                        this.reportData.reportColumnFilter = [
                            null,null,null,null
                        ];
                        this.reportData.reportData = []
                        const hederName = [
                            "userId","userName","depName","answerUser"
                        ] as Array<string>;
                        this.userReportId = {};
                        this.memoList = {};
                        for(const [k,v] of Object.entries(apidata.report)){
                            const reportDetail = v.detail;
                            const answerUser = v.answerUserID?v.answerUserName:this.text.person;
                            const reportData = [
                                v.userId,v.userName,v.depName,v.UP_DATE?answerUser:"",
                            ] as Array<string>;
                            
                            for(const [kD,kV] of Object.entries(reportDetail)){
                                let hedeCode = hederName.indexOf(kV.title);
                                if(hedeCode<0){
                                    //新項目
                                    hederName.push(kV.title);
                                    hedeCode = hederName.length - 1;
                                    this.reportData.reportHeders.push({
                                        "text":kV.title,
                                        "value":hedeCode.toString(),
                                    });
                                }
                                reportData[hedeCode] = kV.value;
                                this.reportColumn[hedeCode] = kV;
                            }
                            this.reportData.reportData.push(reportData);
                            this.userReportId[v.userId] = v.reportID;
                            this.userAnswered[v.userId] = v.UP_DATE?true:false;
                            if(apidata.memo){
                                const memoTemp = apidata.memo.filter(x=>{
                                    return (x.reportID === v.reportID)
                                }).map(y=> {
                                    return{
                                    "update":new Date(y.createDate),
                                    "text":y.messege,
                                    "userName":y.createUserName??"",
                                    }
                                });
                                memoTemp.sort((a,b)=>{
                                    if(a.update.getTime() === b.update.getTime()){
                                        return 0
                                    }else if(a.update.getTime() < b.update.getTime()){
                                        return 1;
                                    }else{
                                        return -1;
                                    }
                                });
                                this.memoList[v.userId] = {
                                    "count":memoTemp.length,
                                    "detail":memoTemp.map(v=>{
                                        return {
                                            "update":v.update,
                                            "updateText":comm.formatDate(v.update,'mm/dd HH:MM'),
                                            "user":v.userName,
                                            "text":v.text,
                                        }
                                    }),
                                }
                            }
                        }
                        this.makeReportCharts();
                    }else if(result.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                }else{
                    comm.ApiErrorMessege(this,comm.unknowError,true);
                }
            },
            async updateEventDetail(){
                if(this.selectEventId){
                    await this.viewEvent(this.selectEventId);
                }
            },
            async closeEventExec(){
                if(this.selectEventId && this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    const result = await this.api.apiRequest.request.admin.finishEvent(this.selectEventId)
                    comm.LoadingOverlay(this,false);
                    if(result.statusCode === 200 && result.data){
                        this.digCloseEvent = false;
                        this.getEcEvent();
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                    }else if(result.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                }else{
                    comm.ApiErrorMessege(this,comm.unknowError,true);
                }
            },
            makeReportCharts(){
                if(this.charts.length>0){
                    for(const chrt of this.charts){
                        chrt.elm.$destroy();
                    }
                }
                const el = this.$refs.charts as Element;
                if(el){
                    el.innerHTML = '';
                }
                this.charts = [];
                //回答済み
                const answerDetail = {
                    all:0,
                    act:0,
                    dct:0,
                }
                for(const ans of this.reportData.reportData){
                    answerDetail.all++;
                    {
                        const [a,b,c,...d] = ans;
                        let allNull = true;
                        for(const str of d){
                            if(str){
                                allNull = false;
                            }
                        }
                        if(allNull){
                            answerDetail.dct++;
                        }else{
                            answerDetail.act++;
                        }
                    }
                }
                this.charts[0] = {
                    "subject":this.text.answer.sub,
                    "data":[answerDetail.act,answerDetail.dct],
                    "labels":[this.text.answer.act,this.text.answer.dct],
                    "elm":new pieComponent(),
                }
                this.charts[0].elm.$mount();
                this.charts[0].elm.sysSet(0,this.charts[0].subject)
                this.charts[0].elm.$on("emphasisSetEvent",(a:any)=>{this.emphasisSet(a)})
                //各項目
                for(const [key,column] of this.reportColumn.entries()){
                    if(column && column.required){
                        const dataset = comm.reportColumnCounter(this.reportData.reportData,key);
                        const addNum = this.charts.push({
                            "subject":column.title,
                            "data":dataset.data,
                            "labels":dataset.labels,
                            "elm":new pieComponent(),
                        });
                        this.charts[addNum-1].elm.$mount();
                        this.charts[addNum-1].elm.sysSet(key,column.title)
                    }
                }
                if(el){
                    for(const c of this.charts){
                        c.elm.update({"data":c.data,"labels":c.labels});
                        c.elm.$on("emphasisSetEvent",(a:any)=>{this.emphasisSet(a)})
                        if(c.elm.$el){
                            el.appendChild(c.elm.$el);
                        }
                    }
                }
                setTimeout(this.chartChk,1);
            },
            chartChk(){
                let offsetBase = 0;
                for(const c of this.charts){
                    const cTop = c.elm.getLegend();
                    if(typeof cTop === "number"){
                        offsetBase = offsetBase<cTop?cTop:offsetBase;
                    }
                }
                for(const c of this.charts){
                    const cTop = c.elm.getLegend();
                    if(typeof cTop === "number"){
                        c.elm.setPadding(offsetBase-cTop);
                    }
                }
            },
            serchInput(){
                this.reportList._serchTxt = `input:${this.reportList.serchTxt}`;
            },
            emphasisSet(a:any){
                this.emphasis = a;
                this.reportList._serchTxt = `chart:${this.reportList.serchTxt}`;
                for(const _c of this.charts){
                    _c.elm.resetEmphasis(this.emphasis.columnId);
                }
            },
            listFilter(value: any, search: string | null, item: any){
                let result = false;
                if(!search){
                    return true;
                }
                const [method,text] = search?.split(':');
                if(this.emphasis.set){
                    if(this.emphasis.columnId === 0){
                        //0=回答状況
                        if(this.emphasis.item === this.text.answer.act && this.userAnswered[item[0]]){
                            //回答済み
                            result = true;
                        }else if(this.emphasis.item === this.text.answer.dct && !this.userAnswered[item[0]]){
                            result = true;
                        }
                    }else if(this.emphasis.columnId){
                        //その他項目
                        if(item[this.emphasis.columnId] && item[this.emphasis.columnId] === this.emphasis.item){
                            result = true;
                        }
                    }
                }
                if(this.emphasis.set && !result){
                    return false;
                }
                result = false;
                if(Array.isArray(item)){
                    for(const val of item){
                        if(typeof val === "string" || typeof val === "number"){
                            result = result?true:val.toString().includes(text?text:"");
                        }  
                    }
                }else if(typeof item === "string" || typeof item === "number"){
                    result = result?true:item.toString().includes(text?text:"");
                }
                return result;
            },
            listMenuOpen(e:MouseEvent,a:Array<string>){
                e.preventDefault();
                this.listMenu.display = true;
                this.listMenu.x = e.clientX;
                this.listMenu.y = e.clientY;
                this.listMenu.userId = a[0];
                this.listMenu.userName = a[1];
                this.listMenu.userDep = a[2];
                this.listMenu.reportId = this.userReportId[a[0]];
            },
            openTip(e:MouseEvent,a:Array<string>){
                const memoUserId = a[0];
                this.memoTip.date = "";
                this.memoTip.user = "";
                this.memoTip.text = "";
                this.memoTip.memoCount = 0;
                if(memoUserId){
                    const memoData = this.memoList[memoUserId];
                    this.memoTip.memoCount = memoData.count;
                    if(memoData.count > 0){
                        this.memoTip.date = memoData.detail[0].updateText;
                        this.memoTip.user = memoData.detail[0].user;
                        this.memoTip.text = memoData.detail[0].text;
                        this.memoTip.otherCount = comm.strReplacePercentObject(this.text.ecMemo.seeOther,{"count":(memoData.count-1).toString()});
                    }
                }
                this.memoTip.display = true;
                this.memoTip.x = e.clientX;
                this.memoTip.y = e.clientY;
            },
            closeTip(){
                this.memoTip.display = false;
                this.memoTip.memoCount = 0;
                this.memoTip.date = "";
                this.memoTip.user = "";
                this.memoTip.text = "";
            },
            answerReport(){
                if(this.listMenu.userId){
                    const urlBase = new URL(document.URL);
                    if(this.listMenu.userId !== this.$store.state.user.userId){
                        window.open(`${urlBase.origin}${urlBase.pathname}?c=eqc&p=y&q=${encodeURIComponent(this.userReportId[this.listMenu.userId])}&au=${this.$store.state.user.proxyUserKey}`);
                    }else{
                        window.open(`${urlBase.origin}${urlBase.pathname}?c=eqc&p=y&q=${encodeURIComponent(this.userReportId[this.listMenu.userId])}`);
                    }
                }
            },
            openMemo(){
                if(this.listMenu.userId){
                    this.memoDetail.userId = this.listMenu.userId;
                    this.memoDetail.userName = this.listMenu.userName;
                    this.memoDetail.userDep = this.listMenu.userDep;
                    this.memoDetail.memos = this.memoList[this.listMenu.userId].detail;
                    this.memoDetail.count = this.memoList[this.listMenu.userId].detail.length
                    this.digMemo = true;
                }
            },
            async inputMemo(){
                if(this.inputMemoText.length === 0){
                    return false;
                }
                if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    const apiResponse = await this.api.apiRequest.request.postEcMemo(this.currentEventId,this.listMenu.reportId,this.inputMemoText);
                    comm.LoadingOverlay(this,false);
                    if(apiResponse.statusCode === 200){
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                        this.inputMemoText = "";
                        await this.updateEventDetail();
                        this.openMemo();
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }else{
                    comm.ApiErrorMessege(this,comm.unknowError);
                }
            },
            exportExcel(){
                this.disExcelBtn = true;
                this.exportExcelSave();
            },
            async exportExcelSave(){
                const workBook = new exceljs.Workbook();
                const sheet = workBook.addWorksheet();
                comm.exceljsUtils.setRow(sheet,{row:1,column:1},this.reportData.reportHeders.map(v=>v.text));
                let row = 2;
                for(const item of this.reportData.reportData){
                    comm.exceljsUtils.setRow(sheet,{"row":row,"column":1},item);
                    row++;
                }
                const _wbBuffer = await workBook.xlsx.writeBuffer();
                fileSaver.saveAs(new Blob([_wbBuffer]),"report.xlsx");
                this.disExcelBtn = false;
            },
        }
    });
</script>